<template>
    <div class="codeCont" :style="{ bottom: bottom }">
        <img :src="require(`../assets/imgs/${pic}/code.png`)" class="codeCont-img">
        <span class="codeCont-font">扫二维码获取更多详情</span>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        bottom: {
            type: String,
            default: '1.8rem'
        },
        pic: {
            type: Number,
            default: 94
        },
    }
}
</script>

<style lang="scss" scoped>
.codeCont {
    width: 4rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .codeCont-img {
        width: 2.5rem;
        height: 2.5rem;
        margin-bottom: 0.2rem;
    }

    .codeCont-font {
        width: 100%;
        color: #fff;
        font-size: 0.3rem;
    }
}
</style>